import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number, initialSeconds: number) {
  const initialTimeInSeconds = initialMinutes * 60 + initialSeconds
  const [timeLeft, setTimeLeft] = useState(initialTimeInSeconds)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          return initialTimeInSeconds
        }
        return prevTime - 1
      })
    }, 1000)

    return () => clearInterval(intervalId)
  }, [initialTimeInSeconds])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(seconds).padStart(2, '0')

  return {
    formatted: `${formattedMinutes}:${formattedSeconds}`,
    totalSeconds: timeLeft,
    isUrgent: timeLeft < 300, // less than 5 minutes
  }
}
